export const hPaddingValue = 16;
export const vPaddingValue = 16;
export const baseSpacingValue = 8;
export const globalRadius = 6;
export const globalBorderWidth = 3;
